<template>
  <div>
    <div
      class="topDiv"
      ref="multi-select-search"
      @focusout="closeDropdownOnFocusOut"
      tabindex="0"
    >
      <div v-if="showLabel" class="acs-input-head">
        {{ label }}
      </div>
      <div class="select-div">
        <div
          @click="!isDisabled ? (showDropdown = !showDropdown) : ''"
          class="
            laptopinput
            align-items-center
            d-flex
            justify-content-between
            pointer pointer
            mt-1
          "
          :class="!isDisabled ? '' : 'disable-inputField'"
        >
          <!-- newManage-dropdown-place   for selected -->
          <span class="inputPlaceholder-font">
            {{
              selectedValues.length == 0
                ? "Select"
                : `${selectedValues.length} Selected`
            }}
          </span>
          <span>
            <img
              v-if="!showDropdown"
              src="../../assets/cvsearch/cv-downarrow.svg"
              alt=""
            />
            <img
              v-else
              class="pointer"
              src="../../assets/cvsearch/cv-uparrow.svg"
              alt=""
            />
          </span>
        </div>
      </div>

      <div
        v-if="showDropdown && !isDisabled"
        class="acess-cj-filter-modal"
        style="width: 100%"
      >
        <div class="relativeclass">
          <!-- <div class="recsearchicon-pos">
            <img src="../../assets/img/accessconnew/inputsearch.svg" alt="" />
          </div>
          <b-form-input
            class="acs-inputField"
            type="search"
            placeholder="Search"
            v-model="search"
          >
          </b-form-input> -->
          <b-form-group class="acs-dd-group">
            <b-form-checkbox-group
              v-model="selectedValues"
              :options="filteredOptions"
              class="w-100 newtp-checkbox"
              value-field="value"
              text-field="text"
              @change="$emit('select-value', selectedValues)"
              :disabled="isDisabled"
            ></b-form-checkbox-group>
          </b-form-group>
          <!-- <div v-if="filteredOptions.length == 0 && search !== ''">
            No {{ label }} found
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiSelectSearch",
  props: {
    label: String,
    showLabel: Boolean,
    placeholder: String,
    options: Array,
    selected: Array,
    isDisabled: Boolean,
  },
  data() {
    return {
      search: "",
      showDropdown: false,
      selectedValues: [],
    };
  },
  created() {
    if (this.selected) {
      this.selectedValues = this.selected;
    }
  },
  watch: {
    selected(oldQ, newQ) {
      if (oldQ !== newQ && this.selected) {
        this.selectedValues = this.selected;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdownOnClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdownOnClickOutside);
  },
  methods: {
    closeDropdownOnClickOutside(event) {
      // Check if the clicked element is not within the component
      if (!this.$refs["multi-select-search"].contains(event.target)) {
        this.showDropdown = false; // Close the dropdown
      }
    },
    closeDropdownOnFocusOut(event) {
      // Check if the focus is outside the custom select component
      if (!this.$refs["multi-select-search"].contains(event.relatedTarget)) {
        this.showDropdown = false; // Close the dropdown
      }
    },
  },
  computed: {
    filteredOptions() {
      return this.options.filter((option) =>
        option.text.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
